/**
 * De stijlen die meer dan één tabblad van het leerkrachtscherm gebruikt.
 *
 * Een tabblad spreidt dit uit in zijn eigen `styles` en zet daar achter wat
 * alleen dat tabblad nodig heeft: `const styles = { ...basis, ...eigen }`.
 */
import { kleur } from '../../theme/tokens';
import { gedeeld } from '../../theme/stijlen';

export const basis = {
  ...gedeeld,
  card: { background: 'white', padding: '24px', borderRadius: '12px', border: '1px solid black' },
  addBtn: { padding: '8px 16px', background: kleur.accent, color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  saveBtn: { padding: '8px 16px', background: kleur.accent, color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  deleteBtn: { background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px' },
  input: { width: '100%', padding: '12px', border: `2px solid ${kleur.lijn}`, borderRadius: '6px', fontSize: '14px', marginBottom: '12px', boxSizing: 'border-box' },
  formButtons: { display: 'flex', gap: '8px' },
  listItemActive: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderRadius: '8px', marginBottom: '8px', cursor: 'pointer', background: kleur.accentLicht, border: `2px solid ${kleur.accent}` },
  beschrijving: { color: kleur.stil, marginBottom: '24px' },
  sessieMeta: { fontSize: '13px', color: kleur.stil },
};
